import styled from "styled-components";
import IconSAT from "../../assets/images/icon-sat.svg"
import React, { useEffect, useRef, useState } from "react";
import UserManagementIcon from "./icon/user-management";
import DashboardIcon from "./icon/dashboard";
import EFManagementIcon from "./icon/ef-management";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import IconArrow from "../../assets/images/icon-arrow-2.svg"
import IconArrowAccount from "../../assets/images/icon-arrow-3.svg"
import IconPerson from "../../assets/images/icon-person.svg"
import IconPersonGray from "../../assets/images/icon-person-gray.svg"
import IconLogout from "../../assets/images/icon-logout.svg"
import CoreAPI from "../../services/core";
import LoadingModal from "../loading-modal";
import ConfirmModal from "../modal/confirm";
import { useOpenModalTokenExpired } from "../../contexts";
import PdfManual1 from "../../assets/documents/คู่มือการใช้งานระบบ.pdf"
import PdfManual2 from "../../assets/documents/คู่มือการสร้างแบบประเมิน.pdf"
import ManualButtonComponent from "./manual-btn";
import IconIGStep from "../../assets/images/icon-ig-step.svg"
import LocationManagementIcon from "./icon/location-management";
import ActivityIcon from "./icon/activity";

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    overflow-x: hidden;
    position: relative;
    background-color: #FBFBFE;
`;

const Sidebar = styled.div`
    width: calc(228px - 48px);
    height: 100%;
    padding: 24px 24px 0px 24px;
    background-color: #FFFFFF;
    position: fixed;
    top: 0px;
    left: 0px;

    .box-header {
        height: 48px;
        /* height: 98px; */

        .image {
            width: 36px;
            height: 36px;
            margin-right: 16px;
        }

        .label {
            color: #25368D;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
        }

        .sub-label {
            margin-top: 8px;
            color: #505050;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            text-align: left;
        }

    }

    .line {
        width: 100%;
        height: 1px;
        background-color: #F2F2F2;
        margin: 24px 0px;
    }

    .box-menu {
        width: 100%;
        height: calc(100% - 216px);
        overflow-x: hidden;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .menu {
        width: calc(100% - 32px);
        height: 48px;
        min-height: 48px;
        padding: 0px 16px;
        background-color: #FFFFFF;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        text-align: left;
        border-radius: 30px;
        cursor: pointer;
        gap: 8px;
        transition: all 0.3s ease;

        &:hover {
            background-color: #FBE25099;
        }

        .icon {
            width: 16px;
            height: 16px;
        }

        .label {
            margin-top: 2px;
            flex: 1;
        }

        .chevron {
            font-size: 11px;
            color: #B5B5B5;
            transition: transform 0.2s ease;
            margin-left: auto;
        }

        .chevron.open {
            transform: rotate(90deg);
        }

        &.active {
            background-color: #FBE250;
            color: #25368D;
            font-size: 15px;
            font-weight: 500;
            text-align: left;

            .chevron { color: #25368D; }
        }

        &.parent-active {
            color: #25368D;
            font-weight: 500;

            .chevron { color: #25368D; }
        }

        &.sub-menu {
            padding-left: 44px;
            font-size: 14px;
            min-height: 40px;
            height: 40px;

            &.active {
                background-color: #FBE250;
                color: #25368D;
                font-weight: 500;
            }
        }
    }

    .bottom-box-menu {
        width: 100%;
        height: 40px;
        margin-top: 16px;
    }
`;

const Main = styled.div`
    width: calc(100% - 228px - 96px);
    /* height:calc(100% - 96px); */
    height:calc(100% - 64px);
    padding: 48px 48px 16px 48px;
    position: absolute;
    top: 0px;
    left: 228px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    width: 100%;
    height: 75px;
    margin-bottom: 16px;
    justify-content: space-between;

    .title-box {
        .main {
            color: #25368D;
            font-size: 30px;
            font-weight: 500;
            line-height: 44.85px;
            text-align: left;
        }

        .sub {
            .core {
                color: #B5B5B5;
                font-size: 15px;
                font-weight: 400;
                line-height: 22.43px;
                text-align: left;
                cursor: pointer;
            }

            .icon {
                margin: 0px 8px;
            }

            .focus {
                color: #505050;
                font-size: 15px;
                font-weight: 400;
                line-height: 22.43px;
                text-align: left;
            }
        }
    }

    .user-box {
        
    }
`;

const ButtonAccount = styled.div`
    position: relative;
    height: 40px;
    cursor: pointer;
    border-radius: 8px;
    padding: 4px 8px;
    transition: all 0.3s ease;

    &:hover {
        background-color: #FBE2504D;
    }

    .image-person-box {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #FBE250;
    }

    .label-name {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin: 0px 16px;
    }

    .image-arrow-box {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        padding-top: 2px;
        cursor: pointer;
        transition: all 0.3s ease;

        .image-arrow {
            transition: all 0.3s ease;

            &.open {
                transform: rotateX(180deg);
            }
        }

        &:hover {
            background-color: #FBE25099;
        }
    }
`;

const DropdownAccount = styled.div`
    width: 180px;
    padding: 8px;
    position: absolute;
    top: 48px;
    right: 0px;
    z-index: 9;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 4px 0px #60606012;
    border-radius: 10px;

    .line {
        width: 100%;
        height: 2px;
        margin: 4px 0px;
        background-color: #F2F2F2;
    }

    .menu {
        height: 48px;
        padding: 0px 8px;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            background-color: #FBE25099;
        }

        .image {
            margin-right: 8px;
        }
    }
`;

const Body = styled.div`
    width: 100%;
`;

const PoweredBox = styled.div`
    width: 100%;
    height: 24px;
    color: #505050;
    font-size: 12px;
    font-weight: 300;
    line-height: 20.93px;
    margin-top: auto;
    margin-bottom: 0px;
    padding-top: 24px;

    .image {
        margin-left: 16px;
    }
`;

// Pick the child whose main_route is the longest matching prefix of `pathname`.
// A child matches when pathname equals main_route OR is nested under it (next
// char is "/"). If a sibling also matches with a longer route, this child is not
// the most specific. Prevents form-compare ("/dashboard") from highlighting on
// /dashboard/usage just because the path string contains "/dashboard".
function isChildMostSpecificMatch(child, siblings, pathname) {
    const r = child?.main_route;
    if (!r) return false;
    const matches = (route) => pathname === route || pathname.startsWith(route + "/");
    if (!matches(r)) return false;
    for (const s of (siblings || [])) {
        if (s === child) continue;
        const sr = s?.main_route;
        if (sr && sr.length > r.length && matches(sr)) return false;
    }
    return true;
}

function BackOfficeLayout({
    children,
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const { setOpenModalTokenExpired } = useOpenModalTokenExpired();
    const [listMenuDefault, setListMenuDefault] = useState([
        {
            name: "User Management",
            label: "User Management",
            main_route: "/user-management",
            route: "/user-management/list-view",
            active: false,
        },
        {
            name: "Dashboard",
            label: "Dashboard",
            main_route: "/dashboard",
            route: "/dashboard",
            active: false,
            children: [
                {
                    name: "Dashboard.FormCompare",
                    label: "สถิติแบบสอบถาม",
                    main_route: "/dashboard",
                    route: "/dashboard",
                },
                {
                    name: "Dashboard.Usage",
                    label: "การใช้งาน",
                    main_route: "/dashboard/usage",
                    route: "/dashboard/usage",
                },
            ],
        },
        {
            name: "EF Management",
            label: "EF Management",
            main_route: "/ef-management",
            route: "/ef-management/list-view",
            active: false,
        },
        {
            name: "Location Management",
            label: "Location Management",
            main_route: "/location-management",
            route: "/location-management/list-view",
            active: false,
        },
        {
            name: "Activity",
            label: "Activity",
            main_route: "/activity",
            route: "/activity/list-view",
            active: false,
        },
        {
            name: "Report",
            label: "Report",
            main_route: "/report",
            route: "/report/evaluation-history",
            active: false,
            children: [
                {
                    name: "Report.History",
                    label: "ประวัติการตอบ",
                    main_route: "/report/evaluation-history",
                    route: "/report/evaluation-history",
                },
                {
                    name: "Report.TopEvaluators",
                    label: "ผู้ตอบยอดนิยม",
                    main_route: "/report/top-evaluators",
                    route: "/report/top-evaluators",
                },
                {
                    name: "Report.RatingSummary",
                    label: "สรุปผลการประเมินรายสถานที่",
                    main_route: "/report/rating-summary",
                    route: "/report/rating-summary",
                },
            ],
        },
    ])
    const [listMenu, setListMenu] = useState([])
    const [menuSelected, setMenuSelected] = useState({
        label: "",
        sub: "",
    })
    const [openAccount, setOpenAccount] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const dropdownRef = useRef(null)
    const buttonDropdownRef = useRef(null)
    const [profile, setProfile] = useState({
        user_username: "",
    })
    const [openLogoutModal, setOpenLogoutModal] = useState(false)
    const [expandedMenu, setExpandedMenu] = useState(null)

    useEffect(() => {
        const init = async () => {
            onInit();
            window.addEventListener('click', eventClickOutsideDropdownAccount)
        };
        init();

        return () => {
            window.removeEventListener('click', eventClickOutsideDropdownAccount)
        }
    }, [])

    function eventClickOutsideDropdownAccount(event) {
        if (dropdownRef.current
            && buttonDropdownRef.current
            && !dropdownRef.current.contains(event.target)
            && !buttonDropdownRef.current.contains(event.target)) {
            setOpenAccount(false);
        }
    }
    async function onInit() {
        //==============================
        CoreAPI.userHttpService.setTokenExpiredHandler(setOpenModalTokenExpired)
        CoreAPI.evaluationFormHttpService.setTokenExpiredHandler(setOpenModalTokenExpired)
        //==============================
        let _profile = localStorage.getItem("profile");
        if (!_profile) {
            _profile = await onGetProfile();
            if (_profile) {
                localStorage.setItem("profile", JSON.stringify(_profile));
                setProfile(_profile)
            }
        } else {
            try {
                _profile = JSON.parse(_profile)
                setProfile(_profile)
            } catch { }
        }
        let list = [...listMenuDefault];
        if (_profile?.user_username !== "superadmin" && _profile?.user_username !== "admin") {
            list = list.filter(x => x.name !== "User Management" && x.name !== "Location Management" && x.name !== "Activity" && x.name !== "Report");
        }
        // if (_profile?.user_division_id) {
        //     list = list.filter(x => x.name !== "User Management");
        // }
        setListMenu(list)
        onSetActiveListMenuByRoutePath(list);
    }
    function onSetActiveListMenuByRoutePath(_listMenu) {
        const currentPath = location.pathname;
        let _menuSelected = null;
        let list = JSON.parse(JSON.stringify(_listMenu));
        list = list.map(value => {
            value.active = (currentPath.includes(value.main_route));
            if (value.active) {
                _menuSelected = { ...value }
                // If the active menu has children, find which child matches and
                // surface it as the menuSelected (so the title shows the child label).
                if (Array.isArray(value.children)) {
                    setExpandedMenu(value.name);
                    const matchedChild = value.children.find(c => isChildMostSpecificMatch(c, value.children, currentPath));
                    if (matchedChild) {
                        _menuSelected = { ...matchedChild };
                    }
                }
            }
            return value;
        })
        if (currentPath.includes("/account")) {
            _menuSelected = {
                name: "Account",
                label: "บัญชีของคุณ",
                main_route: "/account",
                route: "/account",
                active: true,
            }
        } else if (currentPath.includes("/user-management/create-update")) {
            _menuSelected = {
                ..._menuSelected,
            }
            _menuSelected.sub = id ? "แก้ไขข้อมูลสมาชิก" : "เพิ่มสมาชิกใหม่";
        } else if (currentPath.includes("/ef-management/create-update")) {
            _menuSelected = {
                ..._menuSelected,
            }
            _menuSelected.sub = id ? "รายละเอียดแบบสอบถาม" : "สร้างแบบสอบถาม";
        }
        setListMenu(list)
        setMenuSelected(_menuSelected)
    }
    async function onGetProfile() {
        let response = null;
        try {
            response = await CoreAPI.authenHttpService.getProfile();
        } catch { }
        return response
    }
    async function onLogout() {
        try {
            await CoreAPI.authenHttpService.Logout()
        } catch { }
        localStorage.clear();
        navigate(`/login`);
    }

    function handleClickMenu(index) {
        const target = listMenu[index];
        if (Array.isArray(target?.children) && target.children.length > 0) {
            // Parent with children: toggle expansion only, don't navigate.
            setExpandedMenu(prev => prev === target.name ? null : target.name);
            return;
        }
        let _menuSelected = null;
        let list = JSON.parse(JSON.stringify(listMenu));
        list = list.map((v, i) => {
            v.active = (i === index)
            if (v.active) {
                _menuSelected = { ...v }
            }
            return v;
        })
        setListMenu(list)
        setMenuSelected(_menuSelected)
        navigate(_menuSelected.route);
    }

    function handleClickChild(parent, child) {
        setMenuSelected({ ...child });
        navigate(child.route);
    }
    function handleClickToMain() {
        navigate(menuSelected.route);
    }
    function handleClickAccount() {
        navigate(`/account`);
    }
    async function handleClickLogout() {
        setOpenLogoutModal(true);
        setOpenAccount(false);
    }
    async function handleConfirmLogout() {
        setIsLoading(true)
        setOpenLogoutModal(false)
        await onLogout()
    }
    async function handleSelectManual(param) {
        if (Array.isArray(param) && param.length > 0) {
            const value = param[0].value;
            const link = document.createElement("a");
            if (value === "คู่มือการใช้งานระบบ") {
                link.href = PdfManual1;
            } else if (value === "คู่มือการสร้างแบบประเมิน") {
                link.href = PdfManual2;
            }
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            link.click();
        }
    }

    return (
        <Container id="backoffice-layout">
            <LoadingModal open={isLoading} />
            <ConfirmModal
                open={openLogoutModal}
                title={"ยืนยันออกจากระบบ"}
                labelBack={"ยกเลิก"}
                labelConfirm={"ออกจากระบบ"}
                onBack={(e) => setOpenLogoutModal(false)}
                onConfirm={handleConfirmLogout}
            />
            <Sidebar>
                <div className="vertical-center box-header">
                    <div style={{ width: "100%" }}>
                        <div className="vertical-center" title="ระบบเก็บข้อมูลจำนวนผู้ใช้บริการ และแบบสอบถามประเมินความพึงพอใจ">
                            <img className="image" alt="img" src={IconSAT} />
                            <div className="label">การกีฬาแห่งประเทศไทย</div>
                            {/* <div className="label">ระบบเก็บข้อมูลจำนวนผู้ใช้บริการ</div> */}
                        </div>
                        <div>
                            {/* <div className="sub-label">ระบบเก็บข้อมูลจำนวนผู้ใช้บริการ<br />และแบบสอบถามประเมินความพึงพอใจ</div> */}
                            {/* <div className="sub-label">และแบบสอบถามประเมินความพึงพอใจ ของการกีฬาแห่งประเทศไทย</div> */}
                        </div>
                    </div>
                </div>
                <div className="line"></div>
                <div className="box-menu">
                    {listMenu.map((value, index) => {
                        const hasChildren = Array.isArray(value.children) && value.children.length > 0;
                        const isExpanded = hasChildren && expandedMenu === value.name;
                        // For parents, "active" highlight is muted (parent-active) since the
                        // visible focus belongs to the active child.
                        const parentClass = hasChildren
                            ? `menu vertical-center ${value.active ? "parent-active" : ""}`
                            : `menu vertical-center ${value.active ? "active" : ""}`;
                        return (
                            <React.Fragment key={index}>
                                <div
                                    className={parentClass}
                                    onClick={() => handleClickMenu(index)}
                                >
                                    <IconComponent active={value.active} name={value.label} />
                                    <div className="label">{value.label}</div>
                                    {hasChildren && (
                                        <span className={`chevron ${isExpanded ? "open" : ""}`}>▶</span>
                                    )}
                                </div>
                                {hasChildren && isExpanded && value.children.map((child) => {
                                    const isChildActive = isChildMostSpecificMatch(child, value.children, location.pathname);
                                    return (
                                        <div
                                            key={child.name}
                                            className={`menu sub-menu vertical-center ${isChildActive ? "active" : ""}`}
                                            onClick={() => handleClickChild(value, child)}
                                        >
                                            <div className="label">{child.label}</div>
                                        </div>
                                    );
                                })}
                            </React.Fragment>
                        )
                    })}
                </div>
                <div className="bottom-box-menu">
                    <ManualButtonComponent
                        placeholder={"คู่มือการใช้งาน"}
                        list={[
                            { label: "คู่มือการใช้งานระบบ", value: "คู่มือการใช้งานระบบ" },
                            { label: "คู่มือการสร้างแบบประเมิน", value: "คู่มือการสร้างแบบประเมิน" }
                        ]}
                        mode={"single"}
                        openPosition={"top"}
                        onSelect={(e) => { handleSelectManual(e) }}
                    />
                </div>
            </Sidebar>
            <Main id="backoffice-main-layout">
                <Header className="vertical-center">
                    <div className="title-box">
                        <div className="main vertical-center">{menuSelected?.label}
                        </div>
                        {menuSelected?.sub &&
                            <div className="sub vertical-center">
                                <div className="core" onClick={handleClickToMain}>{menuSelected?.label}</div>
                                <img className="icon" alt="img" src={IconArrow} />
                                <div className="focus">{menuSelected?.sub}</div>
                            </div>
                        }
                    </div>
                    <ButtonAccount
                        ref={buttonDropdownRef}
                        className="vertical-center"
                        onClick={(e) => setOpenAccount(!openAccount)}>
                        <div className="image-person-box content-center">
                            <img alt="img" src={IconPerson} />
                        </div>
                        <div className="label-name">{profile.user_username}</div>
                        <div className={`image-arrow-box content-center`} >
                            <img className={`image-arrow ${openAccount ? "open" : ""}`} alt="img" src={IconArrowAccount} />
                        </div>
                        {openAccount &&
                            <DropdownAccount ref={dropdownRef}>
                                <div className="menu vertical-center" onClick={handleClickAccount}>
                                    <img className="image" alt="img" src={IconPersonGray} />
                                    บัญชีของคุณ
                                </div>
                                <div className="line"></div>
                                <div className="menu vertical-center" onClick={handleClickLogout}>
                                    <img className="image" alt="img" src={IconLogout} />
                                    ออกจากระบบ
                                </div>
                            </DropdownAccount>
                        }
                    </ButtonAccount>
                </Header>
                <Body>
                    {children}
                </Body>
                <PoweredBox className="content-center">Powered by <img alt="img" className="image" src={IconIGStep} /></PoweredBox>
            </Main>
        </Container>
    )
}

function IconComponent({ active, name }) {
    return (
        <>
            {
                {
                    "User Management": <UserManagementIcon color={active ? "#25368D" : "#505050"} />,
                    "Dashboard": <DashboardIcon color={active ? "#25368D" : "#505050"} />,
                    "EF Management": <EFManagementIcon color={active ? "#25368D" : "#505050"} />,
                    "Location Management": <LocationManagementIcon color={active ? "#25368D" : "#505050"} />,
                    "Activity": <ActivityIcon color={active ? "#25368D" : "#505050"} />,
                    "Report": <ActivityIcon color={active ? "#25368D" : "#505050"} />,
                }[name]
            }
        </>
    )
}

export default BackOfficeLayout;